import React from "react";
import { Box, Button, Typography, Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";

// Components
import StationCounter from "../../components/StationCounter"; 

// Assets
import backgroundImage2 from "../../../assets/images/home/bg2.png";
import truckImage from "../../../assets/centrum_assets/design/index/secondBGPeeps.png";

const SectionTwo = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#1c1c1c",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          mb: 5,
          maxWidth: { lg: "70%", md: "95%", sm: "90%", xs: "90%" },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mt: { md: 10, lg: 15, xs: 10 },
            mb: 1,
            fontWeight: 700,
            color: "#00b5e2",
          }}
        >
          WE DRIVE PROGRESS
        </Typography>

        <Typography
          variant="h2"
          fontWeight={800}
          sx={{ mb: 2, mt: 1, color: "#0a1a3b", letterSpacing: .5 }}
        >
          FUELING TOMORROW'S CITIES
        </Typography>

        <Typography sx={{ mb: 4, color: "#3a3a3a", fontSize: "2.5rem",  }}>
          We use the power of technology to help us find new ways to go further
          so you can. We create superior value and make a difference in our
          communities, helping people to do more.
        </Typography>

        <Grid container spacing={6}>

          {/* LEFT CONTENT – TEXT HIGHER */}
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              height: "100%",
              order: { xs: 2, md: 1 },
              mt: { xs: 2, md: -5 }   
            }}
          >

            {/* WHITE INFO BOX */}
            <Box
              sx={{
                position: "relative",
                backgroundColor: "#fff",
                width: {lg: '150%', md: '150%', },
                py: 3,
                px: 2,
                borderRadius: 4,
                mr: { lg: -15 },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  right: 0,
                  top: "20px",
                  height: "50px",
                  width: "3px",
              
                  borderRadius: "2px",
                }
              }}
            >
              <Typography
                sx={{
                  // fontSize: "1.5rem",
                  fontSize: {md: '1.5rem', xs: '2rem'},
                  color: "#5f5f5fff",
                  lineHeight: 2,
                  mt: {lg: 2, xs: -8, md: 2},
                  ml: { lg: 10 },
                    mx: { xs: -2, sm: 0 },
                }}
              >
                At Centrum Fuel we are committed to giving you high-quality,
                trusted petroleum products for your vehicles. We work hard every
                day to ensure that our fuel meets the highest standards of quality
                and safety, so you can drive with peace of mind.
              </Typography>
            </Box>

            {/* BUTTON + DYNAMIC COUNTER */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                textAlign: "start",
                // gap: 3,
                // mt: { xs: 5, sm: 8, md: 10, lg: 12 },
                py: 5
                // mb: 10,
              }}
            >
              <Button
                component={Link}
                to="/Stations"
                variant="contained"
                sx={{
                  bgcolor: "#00b5e2",
                  color: "#fff",
                  borderRadius: "30px",
                  px: 3.5,
                  fontWeight: 450,
                  fontSize: "1.8rem",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  "&:hover": { bgcolor: "#009ecb" },
                }}
              >
                LEARN MORE
              </Button>
              {/* Dynamic Station Count Component */}
              <StationCounter />
            </Box>
          </Grid>
          {/* RIGHT IMAGE – LOWERED */}
          <Grid 
            item 
            xs={12} 
            md={8}
            sx={{
              order: { xs: 1, md: 2 },
              mt: { xs: 3, md: 10 }
            }}
          >
            <Box
              component="img"
              src={truckImage}
              alt="Fuel Truck"
              sx={{
                width: "100%",
                height: { xs: 400, sm: 400, md: 360, lg: 380 },
                objectFit: "cover",                               
                objectPosition: "center",                         
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SectionTwo;